module.exports = __webpack_public_path__ + "img/sigfox.8e76c5ae.png";